<template>
  <el-col :span="24" class="mb-4">
    <div class="info">
      <div class="content">
        <i v-if="hasIconInfo" class="el-icon-info"></i>
        <span>
        <strong v-if="title"><u>{{title}}</u> : </strong>
        <slot></slot>
      </span>
      </div>
      <i v-if="hasIconClose" class="el-icon-close" @click="$emit('closeBoxInfos', 'close')"></i>
    </div>
  </el-col>
</template>

<style scoped>

</style>
<script>
export default {
  name: 'BoxInfos',
  props: {
    title: {
      type: String,
      required: false
    },
    hasIconInfo: {
      type: Boolean,
      required: true
    },
    hasIconClose: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
i.el-icon-info {
  color: #0ab1bf;
  font-size: 25px;
  margin-right: 5px;
}

i.el-icon-close {
  cursor: pointer;
  margin: 5px;
  position: absolute;
  right: 0;
  top: 0;
}
.info {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 3px solid #0ab1bf;
  background-color: #ebf3f2;
  padding: 5px;
  font-family: "Dosis", Helvetica, Arial, sans-serif;
}

.content {
  display: flex;
  max-width: 90%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
